import axios from 'axios';
import { API } from '../../App';
import { Button } from '../ui/button';
import { toast } from 'sonner';
import { Trash2, FileText } from 'lucide-react';
import { format } from 'date-fns';

export default function ManageScorecards({ scorecards, onRefresh }) {
  const handleDeleteScorecard = async (scorecardId) => {
    if (!window.confirm('Are you sure you want to delete this scorecard? This cannot be undone.')) {
      return;
    }
    
    try {
      await axios.delete(`${API}/admin/scorecards/${scorecardId}`);
      toast.success('Scorecard deleted successfully');
      onRefresh();
    } catch (error) {
      toast.error('Failed to delete scorecard');
      console.error(error);
    }
  };

  return (
    <div className="bg-white border border-stone-200 rounded-sm">
      <div className="p-6 border-b border-stone-200">
        <h2 className="font-barlow font-bold text-xl text-slate-900 uppercase tracking-tight">
          All Scorecards ({scorecards.length})
        </h2>
      </div>

      {scorecards.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-slate-50">
              <tr>
                <th className="text-left font-barlow font-semibold text-slate-900 uppercase text-xs tracking-wide px-6 py-4">
                  Date
                </th>
                <th className="text-left font-barlow font-semibold text-slate-900 uppercase text-xs tracking-wide px-6 py-4">
                  File Name
                </th>
                <th className="text-left font-barlow font-semibold text-slate-900 uppercase text-xs tracking-wide px-6 py-4">
                  Players
                </th>
                <th className="text-left font-barlow font-semibold text-slate-900 uppercase text-xs tracking-wide px-6 py-4">
                  Uploaded
                </th>
                <th className="text-right font-barlow font-semibold text-slate-900 uppercase text-xs tracking-wide px-6 py-4">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {scorecards.map((scorecard) => (
                <tr key={scorecard.id} className="border-t border-stone-100 hover:bg-stone-50">
                  <td className="px-6 py-4 font-mono text-sm">
                    {scorecard.scorecard_date || 'N/A'}
                  </td>
                  <td className="px-6 py-4 font-inter text-sm text-slate-900">
                    {scorecard.file_name}
                  </td>
                  <td className="px-6 py-4 font-mono text-sm">
                    {scorecard.players?.length || 0}
                  </td>
                  <td className="px-6 py-4 font-inter text-sm text-stone-600">
                    {scorecard.upload_date ? format(new Date(scorecard.upload_date), 'MMM d, yyyy') : 'N/A'}
                  </td>
                  <td className="px-6 py-4 text-right">
                    <Button
                      variant="ghost"
                      onClick={() => handleDeleteScorecard(scorecard.id)}
                      className="text-red-500 hover:text-red-700 hover:bg-red-50"
                    >
                      <Trash2 className="w-4 h-4" />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="p-12 text-center">
          <FileText className="w-16 h-16 text-stone-300 mx-auto mb-4" strokeWidth={1.5} />
          <p className="font-barlow text-xl text-slate-900">No scorecards uploaded yet</p>
        </div>
      )}
    </div>
  );
}
